import { Button } from '@acast-tech/decibel';
import { ArrowDownToLineLightGlyph } from '@acast-tech/decibel-glyphs';

interface DownloadButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  onClick,
  disabled = false,
  label = 'Download',
}) => {
  return (
    <Button
      size="large"
      variant="primary"
      type="button"
      glyph={ArrowDownToLineLightGlyph}
      onClick={onClick}
      disabled={disabled}
      data-testid="download-button"
    >
      {label}
    </Button>
  );
};
